import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { UserService } from '../services/user.service';

@Injectable()
export class NonSsoAuthGuard implements CanActivate {
    constructor(private _router: Router, private _userService: UserService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        const isSsoUser = this._userService.isSsoUser;

        if (!isSsoUser) {
            return true;
        }

        this._router.navigate(['/404']);
        return false;
    }

}



// WEBPACK FOOTER //
// ./src/app/core/non-sso-auth.guard.ts